import classNames from 'classnames';
import React, { ReactElement } from 'react';
import ContentLoader, { type IContentLoaderProps } from 'react-content-loader';

import styles from './styles.module.scss';

const DEFAULT_SKELETON_ANIMATION_SPEED = 0.75;

export interface ISkeletonBaseProps extends IContentLoaderProps {}

const SkeletonBase = ({ className, ...rest }: ISkeletonBaseProps): ReactElement => (
  <ContentLoader
    className={classNames(styles.skeletonBase, className)}
    speed={DEFAULT_SKELETON_ANIMATION_SPEED}
    backgroundColor="currentColor"
    {...rest}
  />
);

export default SkeletonBase;
